import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConsultarUsuarioComponent } from 'src/app/components/core/layouts/modal-consultar-usuario/modal-consultar-usuario.component';
import { EstadoSolicitudEntry } from 'src/app/shared/entrys/estado-solicitud.entry';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AccionRntService } from '../accion-rnt/accion-rnt.service';
import { AjustesRntService } from './ajustes-rnt-service';
import { ModalAjusteRntComponent } from '../../../../../layouts/modal-ajuste-rnt/modal-ajuste-rnt.component';

@Component({
  selector: 'app-ajustes-rnt',
  templateUrl: './ajustes-rnt.component.html',
  styleUrls: ['./ajustes-rnt.component.scss']
})
export class AjustesRntComponent implements OnInit {
  public isCollapsed = true;
  
  dataTabla: DatoPaginadoModel;
  estadoRnt: Array<any> = [];
  estadoSolicitudLista: Array<EstadoSolicitudEntry> = [];
  filtro: FormGroup;
  formUpdate: FormGroup;
  paginaActual: number;
  indexDirty: number[]=[];
  
  constructor(private fb: FormBuilder,
              private ajustesRntService: AjustesRntService,
              private estadoRntService: AccionRntService,
              private establecimientoComercioService: EstablecimientoComercioService,
              private modalService: NgbModal) {
    this.createPagingTable();
    this.initForm();
    this.paginaActual = 1;
   }

  ngOnInit(): void {
    this.onEstadoRNTSelect();
    this.onEstadoSolicitud();
  }
  insertIntoArrayIndex(index: number): void{
    let exists = this.indexDirty.some(x=>x== index);
    if(!exists){
      this.indexDirty.push(index);
    }
  }
  modalChangesSaved(): void{
    this.establecimientoComercioService
                .getParametro({
                  parametro_id:
                    "MENSAJE_MODAL_ACTUALIZACION_AJUSTE_RTN",
                  agrupacion: "VALIDACIONES",
                  auxiliar: "1",
                })
                .subscribe(
                  (resultado2) => {
                    if (resultado2.result) {
                      const modalAceptarRenovacion = this.modalService.open(
                        ModalAjusteRntComponent,
                        { centered: true, backdrop: "static", size: "md" }
                      );
                      modalAceptarRenovacion.componentInstance.mensaje =
                        resultado2.data;
                    }
                  }
                );
  }
  valueFormChanges(): void{
    this.solicitudes.controls.forEach(
      control=>{
        control.valueChanges.subscribe(
          ()=>{
            let indexChanged= this.solicitudes.controls.indexOf(control);
            this.insertIntoArrayIndex(indexChanged);
          }
        )
      }
    )
  }

  getElementsModifiedTorequest():any{
    let request: any[]=[];
    this.solicitudes.value.forEach((item,index) => {
      if(this.indexDirty.includes(index)){
        request.push(item);
      }
    });
    console.log(request);
    return request;
  }
  
  createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
    
	}
  clearFormArraySolicitudes(): void{
		while (this.solicitudes.length !== 0) {
			this.solicitudes.removeAt(0)
		}
	}
  initForm(): void{
    this.filtro = this.fb.group({
      numero_rnt: [null]
    });
    this.formUpdate = this.fb.group({
      solicitudes: this.fb.array([])
    })
  }
  addSolicitud(entry: any):void {

  const solicitudForm = this.fb.group({
        rnt_id:[entry?.rnt_id],
        nuevo_rnt_id:[entry?.rnt_id],
        tipo_rnt:[entry?.tipo_rnt],
        solicitud_id:[entry?.solicitud_id],
        formulario:[entry?.formulario],
        fecha_radicacion:[entry?.fecha_radicacion],
        estado_solicitud:[entry?.estado_solicitud],
        razon_social:[entry?.razon_social],
        matricula:[entry?.matricula],
        nit:[entry?.nit],
        numero_radicacion:[entry?.numero_radicacion],
        estado_solicitud_id: [entry?.estado_solicitud_id, Validators.required],
        estado_rnt_id: [entry?.estado_rnt_id, Validators.required],
        activo: [entry?.activo,Validators.required],
        fecha_inicio_suspension:[entry?.fecha_inicio_suspension],
        fecha_fin_suspension:[entry?.fecha_fin_suspension,[Validators.required]],
        codigo_rnt:[entry?.codigo_rnt],
        fecha_creacion:[entry?.fecha_creacion],
        usuario_creacion:[entry?.usuario_creacion],
        fecha_ultima_actualizacion:[entry?.fecha_ultima_actualizacion,[Validators.required]],
        usuario_ultima_actualizacion:[entry?.usuario_ultima_actualizacion,[Validators.required]],
    });
  
    this.solicitudes.push(solicitudForm);
  }
  getPropAtSolicitudesArray(propName: string,index: number): string{
    return this.solicitudes.at(index).value[propName] ?? '';
  }
  filtrar(): void{
    this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarRnt(1);
  }
  onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarRnt(value);
	}
  onConsultarRnt(page: number) {
		this.ajustesRntService.getDataTable({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
          this.clearFormArraySolicitudes();
          
					this.dataTabla = resultado.data as DatoPaginadoModel;
          this.fillForm();
          this.valueFormChanges();
          this.indexDirty=[];
				}
			});
	}
  onEstadoSolicitud() {
    this.establecimientoComercioService
      .getEstadosSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoSolicitudLista = resultado.data as Array<EstadoSolicitudEntry>;
        }
      });
  }
  limpiar():void{
    this.filtro.reset();
    this.clearFormArraySolicitudes();
		this.createPagingTable();
  }
  onEstadoRNTSelect() {
		this.estadoRntService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRnt = resultado.data;
			}
		});
	}
  onUpdateRnt(): void{
    this.ajustesRntService
        .updateList(this.getElementsModifiedTorequest())
        .subscribe(response=>{
          if(response.result){
            this.modalChangesSaved();
            this.onConsultarRnt(this.paginaActual);
          }
        })
  }
  changeUser(index: number): void{
    const modalConsultarUsuario = this.modalService.open(
      ModalConsultarUsuarioComponent,
      { centered: true, backdrop: "static", size: "sm" }
    );
    modalConsultarUsuario.result.then(result=>{
      if(result.hasOwnProperty('valor')){
        this.solicitudes.at(index).get('usuario_ultima_actualizacion').setValue(result.valor);
      }
    })
  }
  fillForm(): void{    
    this.dataTabla.items.map(x=> this.addSolicitud(x));
  }
  get headerTabla(){
    return['Número RNT','Tipo RNT','Solicitud Id','Descripción (Tipo de Solicitud)',
          'Fecha Radicado','Estado Solicitud','Establecimiento','Matrícula',
          'Nit','Radicado','Estado RNT','Activo','Fecha Inicio Suspensión',
          'Fecha Fin Suspensión','RNT Id','Fecha Creación','Usuario Creación',
          'Fecha Última Actualización','Usuario Última Actualización']
  } 
  get solicitudes() : FormArray{
    return this.formUpdate.controls["solicitudes"] as FormArray;
  }
}
